import Address from './address';
import {setOrFallbackValue} from './helper';
import ADDRESS_TYPES from '../../constants/address_types';

class ShippingAddress extends Address {
    constructor(properties) {
        super(properties);
        this.fsId = setOrFallbackValue(properties, 'fsId', null);
        this.deliveryInstructions = setOrFallbackValue(properties, 'deliveryInstructions', null);
        this.addressType = ('' === setOrFallbackValue(properties, 'addressType', ''))
            ? ADDRESS_TYPES.BUSINESS : properties.addressType;
        this.isFittingStationAddress = setOrFallbackValue(properties, 'isFittingStationAddress', false);
        this.isSupplierAddress = setOrFallbackValue(properties, 'isSupplierAddress', false);
    }
}

export default ShippingAddress;
